
<style>
.container{
 display: flex;
}

.logs-container{
 flex-wrap: wrap;
}

.breadcrumb {
 justify-content: flex-start;
 font-family: Arial, Helvetica, sans-serif;
 font-size: 16px;
 margin-left: 10px;
}

.breadcrumb-link {
  color: #AC242A;
  text-decoration: none;
}

.logs-list-div{
  display:flex;
  justify-content: center;
  align-items: center;
  text-align: left;
  padding-top: 10px;
}

.pagination{
    display:flex;
    justify-content: center;
    align-items: center;
    margin-top: 10px;
}
.ag-theme-alpine{
  font-size: 14px;
  font-family: Arial, Helvetica, sans-serif;
}
</style>

<div class="container" fxLayout="column">
    <div fxLayout="row" class="logs-container">
        <div class="breadcrumb">
            <p>
            <a [routerLink]="'/dashboard'" class="breadcrumb-link">Home</a> /
            <span>Logs</span> 
            </p>
        </div> 
        <div class="logs-list-div">
            <ag-grid-angular
                style="width: 99vw; height: 50vh;"
                class="ag-theme-alpine"
                [columnDefs]="columnDefs"
                [defaultColDef]="defaultColDef"
                [rowData]="rowData"
                [rowSelection]="'multiple'"
                [animateRows]="true"
                
            ></ag-grid-angular>
        </div> 
    </div>
            <div class="pagination">
                <button mat-stroked-button color="primary" (click)="goToPage(1)">First</button>
                <button mat-stroked-button color="primary" (click)="goToPage(currentPage - 1)" [disabled]="rowData.length<10">Previous</button>
                <button mat-stroked-button color="primary">{{ currentPage }}</button>
                <button mat-stroked-button color="primary" (click)="goToPage(currentPage + 1)">Next</button>
                <button mat-stroked-button color="primary" (click)="goToPage(totalPages)" [disabled]="rowData.length<10">Last</button>
            </div>
        
</div>  
